<template>
  <div class="certificate-wrapper" @click.stop="close">
    <div class="mask"></div>
    <div ref="certificate" class="certificate">
      <img class="background" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/a5d14515fb75659df8505b86c2fa2986.png" alt="">
      <img class="close" @click="close" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/e4f688b8d4e34ef78964f2cef65f5138.png" alt="">
      <div class="main-wrapper">
        <div class="main">
          <img class="main-background" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/a2d00c5be7aa0869927b880f8fde1efb.png" alt="">
          <div class="main-content">
            <div class="name">{{info.name}}</div>
            <div>恭喜你完成了
              <span class="active">【{{info.courseName}}—{{info.unitName}}】</span>
              的学习。
            </div>
            <div class="des">你已牢牢掌握本单元学习内容，</div>
            <div class="score active">
              获得了{{info.score}}分的好成绩！
            </div>
          </div>
          <div class="date-wrapper">
            <div class="date">{{formatDate}}</div>
            <div>DATE</div>
          </div>
          <img class="medal" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/bbe9e5857751e50a056adade2fa0ba07.png" alt="">
          <div class="school-wrapper">
            <div class="school-name">{{info.schoolName}}</div>
            <div>SIGNED</div>
          </div>
        </div>
      </div>
      <div class="code-wrapper">
        <div class="code-container">
          <div class="code-main">
            <div>
              <van-q-r-code
                class="code"
                :value="url"
                :options="{ width: 140, type: 'image/png' }"
                tag="img" />
              <div class="active explain">扫一扫分享报告</div>
            </div>
            <img class="rocket" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/9b22f2c469f2c6d60f4d209571b55eb8.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';
import VanQRCode from '@chenfengyuan/vue-qrcode';

export default {
  components: {
    VanQRCode,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    isReplay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formatDate() {
      return utils.Date.format(new Date(this.info.time), 'yyyy.MM.dd');
    },
    url() {
      const {
        certificateId,
      } = this.info;
      const account = utils.storage('account');
      const { id } = account;
      const path = `share/certificate?exam_id=${encodeURIComponent(certificateId)}&user_id=${encodeURIComponent(id)}`;
      return utils.getPassionTeacherUrl(path);
    },
  },
  mounted() {
  },
  data() {
    return {
      image: '',
    };
  },
  methods: {
    close(event) {
      const { className } = event.target;
      if (className === 'certificate-wrapper' || className === 'close') {
        this.$emit('close');
      }
    },
    replay() {
      this.$emit('replay');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .certificate-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 99999;
    .mask {
      position: absolute;
      left: -12%;
      top: -4.1%;
      width: 100vw;
      height: 100vh;
      background: #333;
      opacity: 0.8;
    }
    .certificate {
      position: relative;
      box-sizing: border-box;
      position: relative;
      color: #333;
      border-radius: 18px;
      overflow: hidden;
      .background {
        width: 130vh;
      }
      .close {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #fff;
        cursor: pointer;
      }
      .main-wrapper {
        position: absolute;
        left: 10vh;
        top: 5vh;
        .main {
          position: relative;
          .main-background {
            width: 50vh;
          }
          .main-content {
            position: absolute;
            top: 24vh;
            left: 50%;
            width: 90%;
            font-size: 2vh;
            font-weight: 700;
            text-align: center;
            transform: translateX(-50%);
            div {
              margin-bottom: 1.2vh;
            }
            .name {
              margin-bottom: 1.3vh;
              font-size: 2.2vh;
              color: $primary;
            }
            .des {
              font-size: 2.4vh;
            }
            .score {
              font-size: 2.3vh;
            }
          }
          .medal {
            position: absolute;
            bottom: 6vh;
            left: 50%;
            width: 14vh;
            transform: translateX(-50%);
          }
          .date-wrapper {
            position: absolute;
            bottom: 10vh;
            left: 4vh;
            text-align: center;
            .date {
              width: 14vh;
              margin-bottom: 4px;
              padding-bottom: 4px;
              font-size: 1.9vh;
              color: #976238;
              border-bottom: 1px solid #cf4749;
            }
            div {
              color: #b3afb1;
            }
          }
          .school-wrapper {
            position: absolute;
            bottom: 10vh;
            right: 4vh;
            text-align: center;
            .school-name {
              width: 14vh;
              margin-bottom: 4px;
              padding-bottom: 4px;
              font-size: 1.9vh;
              color: #976238;
              border-bottom: 1px solid #cf4749;
            }
            div {
              color: #b3afb1;
            }
          }
        }
      }
      .code-wrapper {
        position: absolute;
        top: 5.5vh;
        right: 16vh;
        .code-container {
          position: relative;
          display: flex;
          align-items: center;
          width: 27vh;
          height: 20vh;
          border: 1px solid $primary;
          border-radius: 10px;
          .code-main {
            margin-left: 4.5vh;
            /deep/ .code {
              margin-bottom: 5px;
              width: 12vh;
              border: 2px solid $primary;
              border-radius: 10px;
            }
            .explain {
              font-size: 2vh;
              font-weight: 700;
            }
          }
          .rocket {
            position: absolute;
            top: -5vh;
            right: -7.5vh;
            width: 15vh;
          }
        }
      }
    }
    .active {
      color: $primary;
    }
  }
</style>
